import React, { useState, useEffect, useCallback } from 'react';
import useNavigateWithBase from "../hooks/useNavigateWithBase"; // ✅ 新しいフックをインポート
import * as XLSX from 'xlsx';
import axios from 'axios';
import '../CSS/BulkUserUpload.css'; // ✅ CSS 適用

const BulkUserUpload = () => {
  const [users, setUsers] = useState([]);
  const [fileName, setFileName] = useState('');
  const [uploading, setUploading] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState('');
  const navigate = useNavigateWithBase();
  const [companyCode, setCompanyCode] = useState('');

  // 🔹 会社コードの取得（初回レンダリング時）
  useEffect(() => {
    const storedCompanyCode = localStorage.getItem('company_code');
    if (storedCompanyCode) {
      setCompanyCode(storedCompanyCode);
    }
  }, []);

  // 🔹 ファイル選択＆データ変換
  const handleFileUpload = useCallback((event) => {
    const file = event.target.files[0];
    if (!file) return;

    setFileName(file.name);
    
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const parsedData = XLSX.utils.sheet_to_json(sheet);

      const formattedUsers = parsedData.map(user => ({
        name: user['利用者名'] || '',
        email: user['メールアドレス'] || '',
        role: user['権限（責任者なら〇）'] === '○' ? 5.0 : 1.0
      }));

      setUsers(formattedUsers);
    };
    reader.readAsArrayBuffer(file);
  }, []);

  // 🔹 一括登録アップロード処理
  const handleUpload = useCallback(async () => {
    if (!companyCode || users.length === 0) {
      alert('会社コードが取得できないか、ユーザーが未選択です。');
      return;
    }

    setUploading(true);

    try {
      const response = await axios.post(
        "https://hmr25alvt7.execute-api.ap-northeast-3.amazonaws.com/prod/api/users",
        { action: "bulk_add", company_code: companyCode, users },
        { timeout: 300000 }
      );

      alert(response.data.message || "アップロードが完了しました。");
      setDownloadUrl(response.data.signedUrl);
      setUsers([]);
      setFileName('');
    } catch (error) {
      console.error("❌ アップロードエラー:", error);
      alert("アップロードに失敗しました。");
    } finally {
      setUploading(false);
    }
  }, [companyCode, users]);

  // 🔹 テンプレートファイルのダウンロード
  const handleDownloadTemplate = () => {
    const templatePath = `${process.env.PUBLIC_URL}/static/Add-User-List.xlsx`;
    const link = document.createElement('a');
    link.href = templatePath;
    link.setAttribute('download', 'Add-User-List.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="bulk-user-upload">
      <h1>ユーザー一括登録</h1>

      <div className="upload-section">
        <button className="bulk-download-button" onClick={handleDownloadTemplate}>
          テンプレートダウンロード
        </button>
        <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
      </div>

      {fileName && <p>選択されたファイル: {fileName}</p>}

      {users.length > 0 && (
        <>
          <table className="user-preview-table">
            <thead>
              <tr>
                <th>利用者名</th>
                <th>メールアドレス</th>
                <th>権限</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user, index) => (
                <tr key={index}>
                  <td>{user.name}</td>
                  <td>{user.email}</td>
                  <td>{user.role === 5.0 ? '責任者' : '利用者'}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <button className="upload-button" onClick={handleUpload} disabled={uploading}>
            {uploading ? "アップロード中..." : "登録"}
          </button>
        </>
      )}

      {downloadUrl && (
        <a href={downloadUrl} className="download-excel-button" download>
          一括登録ファイルをダウンロード
        </a>
      )}

      <button type="button" className="back-button" onClick={() => navigate('/portal')}>
        ポータルへ戻る
      </button>
    </div>
  );
};

export default BulkUserUpload;
